import React from 'react';
import c from 'classnames';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { CoreLink, DynamicMediaItem } from '@uncinc/react-drupal-core';

import { LinkList, ListCard } from '../../../../components';
import type { TaxonomyTheme } from '../../custom';
import { DEFAULT_LANGUAGE } from '../../../../config/constants';

interface ThemeProps {
  entity: ImmutableEntity<TaxonomyTheme>;
}

const TaxonomyThemeTeaser: React.FC<ThemeProps> = ({ entity }) => {
  const theme = entity.toJS();
  const langcode = theme.langcode[0].value;
  const classes = c('TaxonomyThemeTeaser', 'd-flex', 'h-100');

  const { children = [] } = theme;

  return (
    <div className={classes}>
      <ListCard
        title={theme.name[0].value}
        href={theme.paths[DEFAULT_LANGUAGE]}
        image={(
          <DynamicMediaItem media={theme.field_media_item[0]} imageAspectRatio="16_9" />
        )}
        items={children.length > 0 && (
          <LinkList>
            {children.map((child) => (
              <LinkList>
                <CoreLink href={child.paths[langcode]}>{child.name[0].value}</CoreLink>
              </LinkList>
            ))}
          </LinkList>
        )}
      />
    </div>
  );
};

export default TaxonomyThemeTeaser;
